export default (params) => `
  <soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:web="http://webservice/">
    <soapenv:Header/>
    <soapenv:Body>
      <web:getPayoutCurrencies>
        <destinationCountryId>${params.destinationCountryId}</destinationCountryId>
        <serviceProviderId>${params.serviceProviderId}</serviceProviderId>
        <serviceType>${params.serviceType}</serviceType>
        <payoutBranchCode>${params.payoutBranchCode}</payoutBranchCode>
        <userId>${params.userId}</userId>
        <userKey>${params.userKey}</userKey>
      </web:getPayoutCurrencies>
    </soapenv:Body>
  </soapenv:Envelope>
`